import { createAsyncThunk } from '@reduxjs/toolkit';
import { usersApi } from './usersApi';

export const fetchUsers = createAsyncThunk('users/fetchUsers', async () => {
  const response = await usersApi.fetchUsers();
  return response.data;
});
